import AvailableDateRange from './AvailableDateRange';
import Rate from './Rate';

const roundFactor = (factor: number) => Math.round(factor * 10000) / 10000;

export enum TimePeriod {
	daily = 'daily',
	fixed = 'fixed',
	previous12MonthsAvg = 'previous-12-months-avg',
	previousQuarterAvg = 'previous-quarter-avg',
}

export default class ExchangeRates {
	constructor(
		public readonly id: string,
		public readonly name: string,
		public readonly type: string,
		public readonly availableDateRange: AvailableDateRange | null,
		public readonly baseCurrency: string,
		public readonly date: Date,
		public readonly exchangeRates: Rate[],
		public readonly timePeriod: TimePeriod
	) {}

	isCustom(): boolean {
		return this.type === 'custom';
	}

	calculateExchangeRatesFor(baseCurrency: string | null): Rate[] {
		if (this.baseCurrency === baseCurrency) {
			return this.exchangeRates;
		}

		const baseRateIndex = this.exchangeRates.findIndex((rate) => rate.currency === baseCurrency);
		if (baseRateIndex < 0) {
			return this.exchangeRates;
		}

		const prevBaseRate = new Rate(
			this.baseCurrency,
			String(roundFactor(1 / Number(this.exchangeRates[baseRateIndex].factor)))
		);
		let exchangeRates = [...this.exchangeRates];
		exchangeRates.splice(baseRateIndex, 1);

		exchangeRates = exchangeRates.map((rate) =>
			rate.factorUpdated(String(roundFactor(Number(prevBaseRate.factor) * Number(rate.factor))))
		);
		exchangeRates.push(prevBaseRate);
		exchangeRates.sort((a, b) => a.currency.localeCompare(b.currency));
		return exchangeRates;
	}
}
